export default __webpack_public_path__ + "static/media/arrow-right.56862288.svg";